export function MainBody(props: any) {
    return <div className={`homepage ${props.className}`} id={props.id} >
        {props.children}
    </div>
}